import { render, staticRenderFns } from "./ImpuestosView.vue?vue&type=template&id=c1e8941a&scoped=true"
import script from "./ImpuestosView.vue?vue&type=script&lang=js"
export * from "./ImpuestosView.vue?vue&type=script&lang=js"
import style0 from "./ImpuestosView.vue?vue&type=style&index=0&id=c1e8941a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e8941a",
  null
  
)

export default component.exports